import { keepPreviousData, useInfiniteQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';
import { Pageable, toSearchParams } from '@infuse/api/common';
import { LogMessageSearchOptions, Message as ApiMessage, searchMessages } from '@infuse/api/e-connector/message';
import { mapToDomain } from '@infuse/e-connector/message/domain';
import { last } from 'lodash';

type LogMessagePageOptions = Pick<LogMessageSearchOptions, 'page' | 'size'>;
type LogMessageFilterOptions = Omit<LogMessageSearchOptions, 'page' | 'size'>;

// e-connector doesn't use umbrella for this api
export const useMessages = () => {
  const pageOptions: LogMessagePageOptions = { page: 0, size: 20 };
  const filterOptions = ref<LogMessageFilterOptions>({});

  const query = useInfiniteQuery<Pageable<ApiMessage>>({
    initialPageParam: pageOptions.page,
    queryKey: ['messages', pageOptions, filterOptions],
    queryFn: ({ pageParam }) => {
      pageOptions.page = Number.parseInt(`${pageParam}`);
      return searchMessages({ size: pageOptions.size }, toSearchParams({ ...pageOptions, ...filterOptions.value }));
    },
    getNextPageParam: (lastPage) => (lastPage.last ? undefined : lastPage.pageable.pageNumber + 1),
    placeholderData: keepPreviousData
  });

  const messages = computed(() => query.data.value?.pages.flatMap((page) => page.content?.map(mapToDomain)) || []);
  const currentPage = computed(() => (query.data.value ? (last(query.data.value?.pageParams) as number) : 0));

  return {
    ...query,
    currentPage,
    filterOptions,
    messages
  };
};
